import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ao_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach Bearer token (fallback for browsers/iframes that block third-party cookies).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t && !config.headers?.Authorization) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Capture any token returned by auth responses (login / register).
api.interceptors.response.use((resp) => {
  if (resp?.data?.token) setToken(resp.data.token);
  return resp;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
